export default __webpack_public_path__ + "4872a1843d5b5bb12918747d4637d4ac.png";